
let productSwiperIndex = 0;
let modalActive = false;

function handleProductSwiperCreation() {

  const thumbEl = document.querySelector(".js-productSwiper__thumbnail");
  const mainEl = document.querySelector(".js-productSwiper");
  const thumbEl2 = document.querySelector(".js-productSwiperModal__thumbnail");
  const mainEl2 = document.querySelector(".js-productSwiperModal");
  const modalEl = document.querySelector(".product-media-modal.media-modal");

  if (!mainEl || !thumbEl) return;

  const mainSwiperThumbnail = new Swiper(thumbEl, {
    slidesPerView: 6,
    preventClicks: false,
    preventClicksPropagation: false,
  });

  const mainSwiper = new Swiper(mainEl, {
    loop: true,
    speed: 500,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: mainSwiperThumbnail,
    },
  });

  if (!mainEl2 || !thumbEl2) return;

  const modalSwiperThumbnail = new Swiper(thumbEl2, {
    slidesPerView: 6,
  });

  const modalSwiper = new Swiper(mainEl2, {
    loop: true,
    speed: 500,
    preventClicks: false,
    preventClicksPropagation: false,
    simulateTouch: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: modalSwiperThumbnail,
    },
  });

  function syncSwipers(target, index) {
    if (target.realIndex !== index) {
      target.slideTo(index, 0);
    }
  }

  mainSwiper.on("slideChange", () => {
    if (!modalEl.classList.contains("open") && !modalActive) {
      productSwiperIndex = mainSwiper.realIndex;
      syncSwipers(modalSwiper, productSwiperIndex);
    }
  });

  modalSwiper.on("slideChange", () => {
    if (modalEl.classList.contains("open") && modalActive) {
      productSwiperIndex = modalSwiper.realIndex;
      syncSwipers(mainSwiper, productSwiperIndex);
    }
  });

  const allToggles = document.querySelectorAll(".js-modalToggle");
  allToggles.forEach((el) => {
    el.addEventListener("click", () => {
      const moveMainTo = modalSwiper.realIndex;
      modalEl.classList.toggle("open");
      modalActive = !modalActive;
      document.body.style.overflow = modalActive ? "hidden" : "unset";
      if (!modalActive) {
        mainSwiper.slideToLoop(moveMainTo);
        setTimeout(() => {
          mainSwiper.slideToLoop(moveMainTo, 0);
        }, 10)
        
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  handleProductSwiperCreation();
});